import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { useState } from "react";

import { CreateActorModal } from "Actors/Components/CreateActorModal";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const NewActorButton = (): React.ReactNode => {
  const { t } = useResource();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setIsModalOpen(true)}
        sx={{
          px: Spacing.L,
        }}
      >
        {t(Resources.Common.NewActor)}
      </Button>
      <CreateActorModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
